<template>
  <div>
    <ContentHeader />

    <div class="content-container" v-loading="loading">
      <!-- 订单头部信息 -->
      <div class="order-info-block">
        <div class="order-header">
          <div class="order-number">订单编号: {{ orderInfo.orderNumber }}</div>
          <div class="order-date">
            下单时间: {{ orderInfo.orderDate | parseTime }}
            <span
              class="ongoing"
            >此订单已经进行了{{ getInterval(orderInfo.createDate) }}天</span>
          </div>
          <div class="order-status">订单状态: {{ orderInfo.orderStatusName }}</div>
        </div>
        <OrderStatusStep :order-info="orderInfo" :order-type="orderType"/>
      </div>

      <!-- 订单商品信息 -->
      <div class="order-info-block">
        <div class="block-title">领用资产冰柜信息</div>

        <el-table :data="orderInfo.detailList" :show-header="false" border class="order-detail">
          <el-table-column label="图片名称" width>
            <template slot-scope="scope">
              <el-row>
                <el-col :span="6">
                  <div class="item-image">
                    <img :src="getImageUrl(scope.row.pocmDTO)" />
                  </div>
                </el-col>
                <el-col :span="18">
                  <div class="item-name">{{ scope.row.itemName }}</div>
                  <div>商品编码: {{ scope.row.itemCode }}</div>
                  <div>品牌：{{ scope.row.pocmDTO.itemBrandList[0].abiBrandName }}</div>
                </el-col>
              </el-row>
            </template>
          </el-table-column>

          <el-table-column label="详细信息" width="300">
            <template slot-scope="scope">
                <div>制作周期: {{ scope.row.pocmDTO.productTime }}</div>
                <div>物流周期: {{ scope.row.pocmDTO.deliveryTime }}</div>
                <div>供应商: {{ scope.row.pocmDTO.produceSupplierName }}</div>
            </template>
          </el-table-column>

          <el-table-column label="价格数量">
            <template slot-scope="scope">
                <div>数量: {{ scope.row.itemQuantity }}</div>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="140">
            <template slot-scope="scope">
              <el-button class="btn-blue-plain" size="small" @click="getItemDetail(scope.row)" style="margin-left: 20px">商品详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 收货信息 -->
      <div class="order-info-block">
        <div class="block-title">收货信息</div>
        <el-table :data="orderInfoArray" class="delivery-table">
          <el-table-column label="收货人" prop="receivePerson" />
          <el-table-column label="联系电话" prop="receivePhone" />
          <el-table-column label="收货地址">
            <template slot-scope="scope">{{ getAddress(scope.row) }}</template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 收货信息 -->
      <div class="order-info-block">
        <div class="block-title">售点信息</div>
        <el-table :data="orderInfoArray" class="delivery-table">
          <el-table-column label="售点名称" prop="sfaAddressName" />
          <el-table-column label="售点编码" prop="sfaCode" />
          <el-table-column label="售点联系人" prop="sfaContactPerson"/>
          <el-table-column label="售点电话" prop="sfaContactPhone"/>
        </el-table>
      </div>

      <!-- 订单备注 -->
      <div class="order-info-block">
        <el-row>
          <el-col :span="3">
            <div class="block-title">订单备注</div>
          </el-col>
          <el-col :span="21">
            <div class="order-remark">{{ orderInfo.orderRemark }}</div>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/content-header'
import OrderStatusStep from './components/order-status-step'
import { commonUtils } from '@/utils/common'
import { create, all } from 'mathjs/number'
const math = create(all)
export default {
  name: 'order-info',
  components: {
    ContentHeader,
    OrderStatusStep
  },
  data () {
    return {
      loading: false,
      orderInfo: {},
      orderType: '',
      deliveryList: [],
      totalAmount: 0,
      imageList: [],
      isUpload: false,
      itemIndex: null,
      orderInfoArray: []
    }
  },
  computed: {
    itemCount () {
      return this.orderInfo.detailList ? this.orderInfo.detailList.length : 0
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.orderType = this.$route.query.orderType
      this.queryOrderById()
    },

    // 获取订单详情
    queryOrderById () {
      this.loading = true
      this.$store.dispatch('queryQuotaOrderInfo', this.$route.query.orderId).then(res => {
        this.loading = false
        if (res.data.resultCode === '0') {
          this.orderInfo = res.data.resultData.quotaOrderDTO
          this.orderInfoArray.push(this.orderInfo)
          this.getTotalAmount()
          this.getDeliveryList()
        }
      }).catch(() => {
        this.loading = false
      })
    },

    getTotalAmount () {
      this.totalAmount = 0
      this.orderInfo.detailList.map(item => {
        this.totalAmount = math.add(
          this.totalAmount,
          math.multiply(item.purchasePrice, item.purchaseQuantity)
        )
      })
    },

    // 获取订单地址
    getDeliveryList () {
      this.deliveryList = []
      this.orderInfo.detailList.map(item => {
        this.deliveryList = this.deliveryList.concat(item.deliveryList)
      })
    },

    // 地址
    getAddress (address) {
      return `${address.provinceName} ${address.cityName} ${address.countyName} ${address.detailAddress}`
    },

    changeUpload () {
      this.isUpload = !this.isUpload
    },

    // 查看商品详情
    getItemDetail (row) {
      this.$router.push({ path: '/freezer/detail', query: { freezerId: row.itemId, detailId: row.detailId, from: 'apply' } })
    },

    // 获取间隔时间
    getInterval (time) {
      let date = new Date().getTime()
      let intervalDate = date - time
      return Math.floor(intervalDate / 86400000) + 1
    },

    getImageUrl (item) {
      let imageUri = ''
      if (item.imageList && item.imageList.length > 0) {
        imageUri = item.imageList[0].imageFileUri
      }
      return commonUtils.getImageUrl(imageUri)
    }
  }
}
</script>

<style lang="scss" scoped>
.order-info-block {
  border-radius: 10px;
  background-color: $base-white;
  padding: 20px;
  margin-bottom: 20px;

  .block-title {
    line-height: 32px;
  }
}
.order-header {
  .order-number {
    font-size: 18px;
    font-weight: 700;
    line-height: 30px;
  }
  .order-date {
    font-size: 16px;
    line-height: 30px;
  }
  .ongoing {
    margin-left: 15px;
  }
  .order-status {
    color: $base-red;
    padding: 16px 0;
  }
}

.order-detail {
  width: 100%;
  .item-image {
    width: 65px;
    height: 65px;
    margin: 0 auto;
    border: 1px solid $base-grey;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    img {
      max-width: 90%;
      max-height: 90%;
    }
  }

  .item-name {
    text-align: left;
    font-weight: 700;
  }

  .item-sum {
    font-weight: 700;
  }
}

.order-amount {
  border: 2px dashed #db3e3e;
  margin: 10px 0 0 0;
  padding: 0 20px;
  color: #db3e3e;
  font-size: 16px;
  line-height: 32px;
}

.dotted-block {
  border: 2px dashed $base-grey3;
  vertical-align: middle;
  height: 80px;
}

.budget-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 30px;
  }
}
.entity-info-block {
  padding: 0 30px 0 0;
  p {
    margin-top: 15px;
  }
}

.delivery-table {
  ::v-deep th {
    background-color: $base-grey3;
  }
}

.order-remark {
  line-height: 32px;
}

.order-info-box {
  .order-info-card {
    width: 400px;
    height: 90px;
    border: 1px dashed #ccc;
    border-radius: 5px;
    box-sizing: border-box;
    padding: 10px 40px;
    div {
      margin-top: 12px;
    }
    &.card-red {
      border-color: $base-red;
      color: $base-orange;
      padding: 5px 100px;
      div {
        margin-top: 8px;
      }
    }
  }
}
.list-text {
  padding-bottom: 5px;
  display: inline-block;
}
.order-input {
  display: flex;
  margin: 10px 0;
  .el-input {
    width: 200px;
  }
}
.prints-img {
  display: flex;
  align-items: center;
  & > div:nth-child(2) {
    width: 50px;
    height: 50px;
    img {
      max-width: 100%;
      max-height: 100%
    }
  }
}
.prints-ai {
  margin: 10px 0;
}
</style>
